import * as process from 'process';
const MISSING_ENV_STR = '{missing_env}';
const CONSTANTS = {
    PLATFORM_API_URL: process.env.compTestMode
        ? 'https://au-ecom-sit.inchcapedigital.com/platform-api'
        : String(import.meta.env.VITE_APP_PLATFORM_API_URL) || MISSING_ENV_STR,
    APP_CONFIG_BASE_URL: String(import.meta.env.VITE_APP_CONFIG_BASE_URL) || MISSING_ENV_STR,
    // Currently this locale code displays both currency and decimals in the required format.
    // If a case presents where the USD and decimal need to be displayed differently,
    // the desired locale code should come from the platform configuration.
    USD_CURRENCY_DEFAULT_LOCALE_CODE: 'en-GB',
    DIMENSIONS: {
        brand: String(import.meta.env.VITE_APP_BRAND) || MISSING_ENV_STR,
        country: String(import.meta.env.VITE_APP_COUNTRY) || MISSING_ENV_STR,
        region: String(import.meta.env.VITE_APP_REGION) || MISSING_ENV_STR,
        language: String(import.meta.env.VITE_APP_LANGUAGE) || MISSING_ENV_STR,
    },
    THEME_FILE: `${String(import.meta.env.VITE_APP_WIDGET)}`.toLowerCase(),
    STYLING_SEED: `${String(import.meta.env.VITE_APP_WIDGET)}-widget`.toLowerCase(),
    MERCADOPAGO: {
        public_token: String(import.meta.env.VITE_APP_PUBLIC_TOKEN_MERCADOPAGO) ||
            MISSING_ENV_STR,
    },
};
export default CONSTANTS;
//# sourceMappingURL=constants.js.map